module.exports = __webpack_public_path__ + "printable_checklist-ff9277f086ba37748e57f78d7d8bd1be.png";